<div class="app-avatar"
     [style.height]="size + 'px'"
     [style.width]="size + 'px'"
     [style.font-size]="size / textSizeRatio"
     [style.background-color]="stringToHslColor(name)">
  {{ reducedName }}
</div>
